module.exports = __webpack_public_path__ + "static/news-f9a591c562f44e01734a99153b8acca7.jpg";